import { HexMap } from "../../../Data/HexMap/HexMap"
import { KeyRelationship, Note } from "../../../Data/HexMap/Note"
import { useNoteNames } from "../../../Project/ProjectStore"

export function CommonChords(props:{map:HexMap, noteIndexes:number[]}){
    const noteNames:string[] = useNoteNames()
    const getChordType = (noteIndex:number) => {
        const position:number = getVisibleKeyPosition(noteIndex)
        if([0,3,4].includes(position)){return 'maj'}
        if([1,2,5].includes(position)){return 'min'}
        return 'dim'        
    }
    const getVisibleKeyPosition = (noteIndex:number) => {
        const note:Note = props.map.notes[noteIndex]
        const kr:KeyRelationship|undefined = note.keys.find((kr:KeyRelationship)=>{
            const keyIsVisible = props.map.keys.flat()[kr.keyIndex].visible
            return keyIsVisible
        })
        if(kr !== undefined){
            return kr.position
        }
        return -1
    }
    const getUniqueChordNames = () => {
        const commonChordNames:string[] = props.noteIndexes.map(
            (noteIndex:number)=>{
                const tonic:number = props.map.notes[noteIndex].params.tonic
                return noteNames[tonic] + getChordType(noteIndex)
            }
        )
        const uniqueCommonNotes = Array.from(new Set(commonChordNames))
        return uniqueCommonNotes.sort()
    }
    const ChordName = (props:{name:string, index:number}) => {
        const comma:string = (props.index === 0) ? '' : ', '
        return <span className={'common-chord'}>{comma}{props.name}</span>
    }
    return(
        <span className={'common-chords'}>
        [
            {getUniqueChordNames().map(
                (noteName:string, index:number)=>{ 
                    return <ChordName name={noteName} index={index}/>
                }
            )}
        ]
        </span>
    )
}